import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import {
  pageAnimation,
  fade,
  lineAnimation,
  slider,
  sliderContainer,
} from "../animation";
import ScrollTop from "../components/ScrollTop";

const History = styled(motion.div)`
  min-height: 100vh;
  overflow: hidden;
  padding: 5rem 10rem;
  background-color:rgb(255, 54, 54);
  h2 {
    padding: 1rem 0;
  }
  p {
    padding: 1rem 0;
    line-height: 1.5;
  }
  @media only screen and (min-width: 821px) and (max-width: 1200px) {
    padding: 3rem 5rem;
  }
  /* Kindle and iPad tablet  */
  @media only screen and (min-width: 540px) and (max-width: 820px) {
    padding: 3rem 2.5rem;
  }
  /* Mobile devices iPhone, Pixel */
  @media only screen and (min-width: 320px) and (max-width: 539px) {
    padding: 2.5rem 1rem;
    h2 {
      font-size: 3rem;
      text-align: center;
    }
  }
`;

const OurHistory = () => {
  return (
    <History variants={pageAnimation} initial="hidden" animate="show" exit="exit">
      <motion.div variants={sliderContainer}></motion.div>
        <Frame1 variants={slider}></Frame1>
        <Frame2 variants={slider}></Frame2>
        <Frame3 variants={slider}></Frame3>
        <Frame4 variants={slider}></Frame4>
  <motion.h2 variants={fade}>Our History</motion.h2>
  <motion.div variants={lineAnimation} className="line"></motion.div>
  <motion.p variants={fade}>
    At Burgred, our journey began in 2020, the year when the world was shaken by the COVID - 19 pandemic.Like many businesses, we faced unimaginable challenges—lockdowns, uncertainty, and financial strain.But despite the odds, we never lost sight of our passion for good food and our belief in the power of community.We fought hard to keep our doors open, finding innovative ways to serve our loyal customers during the toughest of times.
  </motion.p>
  <motion.p variants={fade}>
    Through hard work, determination, and the unwavering support of our customers, we not only survived—we thrived.In 2022, we reached a major milestone by moving into a larger space, allowing us to expand our menu and serve even more people with our signature burgers, French tacos, and crispy fried chicken adding for the first time a fried french tacos knowing as the krusty who became our best seller and the taccopizza who is a combination between the French, Mexican and Italian food.
  </motion.p>
  <motion.p variants={fade}>
    Today, we're proud to share that the dream doesn't stop here.We've hit our goals, and with a growing fanbase, we're now ready to take the next big step: expanding to new cities and opening multiple branches.Each new location will carry the same dedication to quality, creativity, and the flavors that make us who we are.
  </motion.p>
  <motion.p variants={fade}>
    From the humble beginnings of 2020 to our exciting future ahead, we're more than just a restaurant—we're a symbol of resilience, growth, and the relentless pursuit of passion. We can't wait to bring our food and our love for the community to more cities across the world.
  </motion.p>
  <ScrollTop />
</History>
  );
};

export default OurHistory;

const Frame1 = styled(motion.div)`
  position: fixed;
  left: 0;
  top: 10%;
  width: 100%;
  height: 100vh;
  background-color: #fffebf;
  z-index: 2;
`;
const Frame2 = styled(Frame1)`
  background-color: #ff8efb;
`;
const Frame3 = styled(Frame1)`
  background-color: #8ed2ff;
`;
const Frame4 = styled(Frame1)`
  background-color: #8effa0;
`;
